import Link from 'next/link';
import React from 'react';
import { useUser } from '../../hooks';
import { Multimedia, Company } from '../../models';

interface UserPhotoProp {
  className: string;
}

function UserPhoto({ className }: UserPhotoProp) {
  const [user] = useUser();
  const src =
    user?.userType === 'admin'
      ? (user?.photo as Multimedia)?.src
      : (user?.company as Company)?.logo?.src;

  return (
    <div className={className}>
      <Link href="/app/profile">
        <div className="md:block h-[35px] px-2">
          <img
            className=" h-8 w-8 object-cover overflow-hidden rounded-full "
            alt="logo"
            src={src ?? '/images/user-fallback.png'}
          />
        </div>
      </Link>
    </div>
  );
}

export default UserPhoto;
